import { gql } from "@apollo/client";
import { fragments as hddOrderStatusFragments } from "../../application/apps/HDDPressApp/components/HDDOrderStatus/graph";

const markOrderAsHighDefinitionDigitalCompletedMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsHighDefinitionDigitalCompleted(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...HDDOrderStatus_order
      }
      succeeded
    }
  }
  ${hddOrderStatusFragments.order}
`;

export default markOrderAsHighDefinitionDigitalCompletedMutation;
